<template>
  <div class="ended-page">
    <div class="ended-page__card">

      <!-- Header -->
      <div class="ended-page__header">
        <v-icon size="64" color="blue-lighten-2" class="ended-page__icon">
          mdi-video-off
        </v-icon>

        <h1 class="ended-page__title">Meeting Ended</h1>

        <p class="ended-page__sub">
          Your session has ended successfully. Thank you for choosing <strong>DSS Meet</strong>.
        </p>
      </div>

      <v-divider class="my-6" />

      <!-- Loading -->
      <div v-if="loading">
        <v-skeleton-loader
          type="list-item-two-line@5"
          color="#1e1e1e"
        />
      </div>

      <!-- Data -->
      <div v-else-if="clientData" class="ended-page__content">
        <h3 class="ended-page__section-title">Practice Details</h3>

        <v-table density="compact" class="ended-page__table">
          <tbody>
            <tr>
              <td class="ended-page__label">Practice Name</td>
              <td>{{ clientData.name || 'Not available' }}</td>
            </tr>
            <tr>
              <td class="ended-page__label">Address</td>
              <td>{{ clientData.address_line_1 || 'Not available' }}</td>
            </tr>
            <tr>
              <td class="ended-page__label">City</td>
              <td>{{ clientData.city || 'Not available' }}</td>
            </tr>
            <tr>
              <td class="ended-page__label">State</td>
              <td>{{ clientData.state || 'Not available' }}</td>
            </tr>
            <tr>
              <td class="ended-page__label">Email</td>
              <td>{{ clientData.email || 'Not available' }}</td>
            </tr>
          </tbody>
        </v-table>
      </div>

      <!-- Empty State -->
      <div v-else class="ended-page__empty">
        <p>
          Practice information is not available for this session.
        </p>
      </div>

    </div>
  </div>
</template>

<script>
import VideoService from '../services/videoService.js';

export default {
  name: 'MeetingEnded',

  data() {
    return {
      clientData: null,
      loading: false,
    };
  },

  async created() {
    const sessionId = this.$route.query.sessionId;
    const isLoggedIn = this.$store.getters.loggedIn;

    // Prevent unnecessary API call
    if (!sessionId || !isLoggedIn) return;

    this.loading = true;

    try {
      const res = await VideoService.getSessionClientSummary(sessionId);
      this.clientData = res?.data || null;
    } catch (error) {
      console.error('Error fetching session summary:', error);
    } finally {
      this.loading = false;
    }
    setTimeout(() => {
      window.close();
    if (!isLoggedIn) {
    setTimeout(() => this.tryCloseTab(), 3500);
    }
    }, 5000);
  },

  methods: {
        tryCloseTab() {
      if (window.history.length <= 2 || window.opener !== null) {
        window.close();
      } else {
        this.goBack();
      }
    },
    goBack() {
      if (this.$store.getters.loggedIn) {
        this.$router.push('/conversation');
      } else {
        this.$router.push('/');
      }
    }
  },
};
</script>

<style scoped>
.ended-page {
  min-height: 100vh;
  background: radial-gradient(circle at top, #1a1a2e, #0f0f0f 70%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.ended-page__card {
  max-width: 560px;
  width: 100%;
  background: rgba(30, 30, 30, 0.75);
  backdrop-filter: blur(14px);
  border-radius: 20px;
  padding: 44px 36px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.6);
  transition: 0.3s ease;
}

.ended-page__card:hover {
  transform: translateY(-4px);
}

.ended-page__header {
  text-align: center;
}

.ended-page__icon {
  background: rgba(255, 255, 255, 0.05);
  padding: 18px;
  border-radius: 50%;
  margin-bottom: 12px;
}

.ended-page__title {
  font-size: 2rem;
  font-weight: 600;
  color: #ffffff;
}

.ended-page__sub {
  color: #a0a0a0;
  font-size: 0.95rem;
  margin-top: 6px;
}

.ended-page__section-title {
  font-size: 1.05rem;
  font-weight: 600;
  color: #d0d0d0;
  margin-bottom: 14px;
}

.ended-page__table {
  background: rgba(255, 255, 255, 0.02) !important;
  border-radius: 10px;
}

.ended-page__table td {
  padding: 12px 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.ended-page__table tr:last-child td {
  border-bottom: none;
}

.ended-page__label {
  color: #9aa0a6;
  width: 140px;
}

.ended-page__table td:last-child {
  color: #ffffff;
  font-weight: 500;
}

.ended-page__empty {
  text-align: center;
  color: #888;
  font-size: 0.9rem;
}

.ended-page__actions {
  margin-top: 28px;
}

.v-btn {
  width: 100%;
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  color: white !important;
  font-weight: 600;
  border-radius: 12px;
  padding: 14px;
  text-transform: none;
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);
}

.v-btn:hover {
  transform: translateY(-2px);
}
</style>